import { render, staticRenderFns } from "./TipoTicketEdit.vue?vue&type=template&id=a4bfd0d8&scoped=true"
import script from "./TipoTicketEdit.vue?vue&type=script&lang=js"
export * from "./TipoTicketEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4bfd0d8",
  null
  
)

export default component.exports